import { makeStyles } from 'tss-react/mui';

export const useProductDetailsContentHeaderButtonsStyles = makeStyles()((theme) => ({
  container: {
    display: 'flex',
    alignItems: 'center',
    flexShrink: 0,
    gap: theme.spacing(1.25),
    marginInlineStart: 'auto',
    transition: theme.transitions.create('all', {
      duration: theme.transitions.duration.standard,
    }),
    [theme.breakpoints.down('lg')]: {
      position: 'absolute',
      zIndex: 11,
      gap: theme.spacing(1),
      right: theme.spacing(1),
      top: theme.spacing(1),
    },
  },
  iconButton: {
    '&:hover': {
      backgroundColor: theme.palette.action.hover,
    },
    [theme.breakpoints.down('lg')]: {
      backgroundColor: theme.palette.secondary.main,
      width: 40,
      height: 40,
      boxShadow: theme.shadows[2],
    },
  },
}));
